'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/react/react.js
// module id = 2
// module chunks = 21